if (typeof Connect == 'undefined') Connect = {};
Connect.Router = Core.SubRouter.extend({

    routes: {
        'scaniafmp-new': 'scaniaFMPNew',
		'CSATResults': 'CSATResults',
        ':id': 'connect',
        'fortnox/auth/:id/:status': 'fortnoxAuth'
    },

    scaniaFMPNew: function() {
        app.setMainView(new Connect.ScaniaFMPNewView());
    },

	CSATResults: function() {
		app.setMainView(new Connect.UngappedCSATResultsView());
	},

    connect: function(id) {
        app.setMainView(new Connect.IntegrationsView({groupUuid: id}), 'directory');
    },
    fortnoxAuth: function(id, status) {
        if (!['success', 'error'].includes(status)) return this.connect(id);
        app.setMainView(new Connect.FortnoxAuthView({ groupUuid: id, status: status}));
        return false;
    },
});
